<template>
  <div class="contents">
    <div class="d-flex section-title-with-back">
      <img src="@/assets/images/Icon awesome-chair_bk.png" alt="" width="27.3" height="25.2" />
      <p class="title-bk">クラス管理</p>
    </div>
    <div class="d-flex section-subtitle-with-back">
      <router-link :to="{ name: 'class' }">戻る</router-link>
    </div>
    <div class="container">
      <label>クラス凍結 ー </label>
      <label class="label lb-red">注意：この作業はスタッフ二人以上で確認の上実行してください</label>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row" width="30%">法人名（法人ID）：</th>
            <td>{{ currentCorporationDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">ブランド名（ブランドID）：</th>
            <td>{{ currentBrandDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">教場名（教場ID）：</th>
            <td>{{ currentSchoolDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">コース名（コースID）：</th>
            <td>{{ currentCourseDisplay }}</td>
          </tr>
          <tr>
            <th scope="row">クラス名（クラスID）：</th>
            <td>{{ currentTamaiClass.name }} ({{ currentTamaiClass.uid }})</td>
          </tr>
          <tr>
            <th scope="row">凍結開始月：</th>
            <td>
              <v-select
                tag="div"
                v-model="frozenMonth"
                placeholder="選択してください"
                class="custom-select mr-sm-2"
                id="inlineFormCustomSelect-2"
                style="width: 180px;"
                :clearable="false"
                :options="frozenMonthJPs"
                :reduce="(option) => option.value"
                label="text"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <table class="table">
        <tbody>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-0"
                  v-model="allStudentFrozenChecked"
                />
                <label class="custom-control-label" for="column-display-check-0">
                  このクラスに関連づけられている全ての生徒は、所属クラスの変更かID凍結を実行しました。
                  <br />
                  実行していない場合、残っている生徒も同時に凍結処理されることを理解しています。
                </label>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-1"
                  v-model="noStudentDuringHolidaysChecked"
                />
                <label class="custom-control-label" for="column-display-check-1">
                  休会中、仮登録中の生徒にも、このクラスに関連づけられている生徒がないことを確認しました。
                </label>
              </div>
            </th>
          </tr>
          <tr>
            <th scope="row">
              <div class="custom-control custom-checkbox">
                <input
                  type="checkbox"
                  class="custom-control-input"
                  id="column-display-check-2"
                  v-model="noStudentChecked"
                />
                <label class="custom-control-label" for="column-display-check-2">
                  別の手段でID凍結を予約している生徒がいる場合、凍結開始月の情報は、ここで設定した凍結開始月の情報に上書きされます。
                  <br />
                  上書きされる生徒がいないこと、もしくは上書きされても影響がないことを確認しました。
                </label>
              </div>
            </th>
          </tr>
        </tbody>
      </table>
      <div class="m-5 text-center">
        <button
          type="button"
          class="btn btn-red"
          @click="confirmFrozen"
          :disabled="!frozenMonth || !allStudentFrozenChecked || !noStudentDuringHolidaysChecked || !noStudentChecked"
        >
          凍結実行
        </button>
      </div>
      <PopUpHolder
        ref="popup_holder"
        no-close-on-esc
        no-close-on-backdrop
        green-button-title="一覧に戻る"
        @greenClick="popupConfirmed"
      >
        <template v-slot:header>クラス凍結</template>
        <template v-slot:body>クラスの凍結、または凍結予約が完了しました</template>
      </PopUpHolder>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapState, mapActions } from 'vuex';
import store from '@/store/index.js';
import PopUpHolder from '@/components/popups/PopUpHolder.vue';
import {
  basicCorporationNameIdPresent,
  basicBrandNameIdPresent,
  basicSchoolNameIdPresent,
  basicCourseNameIdPresent,
} from '@/presenters/fields';
import { nextNMonthJPs } from '@/utils/year_helpers';
import { nextNDayJPs } from '@/utils/date_helpers';

export default {
  props: {
    id: {
      type: [String, Number],
      required: true,
    },
  },
  components: {
    PopUpHolder,
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    if (routeTo.params.id) {
      store.dispatch('tamai_class/fetchTamaiClass', routeTo.params.id).then(() => {
        next();
      });
    } else {
      next();
    }
  },
  data() {
    return {
      frozenMonth: null,
      allStudentFrozenChecked: false,
      noStudentDuringHolidaysChecked: false,
      noStudentChecked: false,
    };
  },
  computed: {
    currentTamaiClass() {
      return this.tamai_class.tamaiClass;
    },
    currentCorporationDisplay() {
      return basicCorporationNameIdPresent(this.currentTamaiClass.corporation);
    },
    currentBrandDisplay() {
      return basicBrandNameIdPresent(this.currentTamaiClass.brand);
    },
    currentSchoolDisplay() {
      return basicSchoolNameIdPresent(this.currentTamaiClass.school);
    },
    currentCourseDisplay() {
      return basicCourseNameIdPresent(this.currentTamaiClass.course);
    },
    frozenMonthJPs() {
      let numberOfMonths = 12;
      let arrayOfMonths = [];
      if (Vue.config.stagingBuild) {
        arrayOfMonths = nextNDayJPs(numberOfMonths);
      } else {
        arrayOfMonths = nextNMonthJPs(numberOfMonths);
      }
      arrayOfMonths.unshift({
        value: 'now',
        text: '今すぐ凍結',
      });
      return arrayOfMonths;
    },
    ...mapState(['tamai_class']),
  },
  methods: {
    confirmFrozen() {
      this.$logger.debug('Confirm frozen');
      let payload = {
        id: this.currentTamaiClass.id,
        frozenMonth: this.frozenMonth,
      };
      this.freezeTamaiClass(payload).then(() => {
        this.$logger.debug('Show success popup');
        this.$refs['popup_holder'].show();
      });
    },
    popupConfirmed() {
      this.$logger.debug('Popup done');
      this.$router.push({ name: 'class' });
    },
    ...mapActions('tamai_class', ['freezeTamaiClass']),
  },
};
</script>

<style scoped>
.btn-red {
  margin-left: 0px;
}
.lb-red {
  color: red;
  margin-left: 5px;
}
.custom-control-label {
  font-weight: normal;
  font-size: 13px;
}
</style>
